import * as React from 'react'
import * as Styled from './SpeedTest.styles'

const SpeedTest = ({ speedTestId, style, url }) => (
  <Styled.SpeedTest className="leshen-speed-test-module">
    <div id={speedTestId} style={style} />
    <script src={url} />
  </Styled.SpeedTest>
)

export default SpeedTest
